import Expander from '@/modules/Expander/Expander.js';
import PlacesList from './PlacesList.js';

const initPlacesList = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="places-list"]'));

  elements.forEach((element) => {
    new Expander(element, {
      shownClass: 'extended',
      hiddenClass: 'collapsed',
      togglerTitleTag: 'span',
    });

    new PlacesList(element);
  });
};

export default initPlacesList;
